<template>
  <extraction-saisie :title="title" :file-name="fileName"></extraction-saisie>
</template>

<script>
  import ExtractionSaisie from './ExtractionSaisie';

  export default {
    name: "ExtractionSaisieParDate",
    components: { ExtractionSaisie },
    data() {
      return {
        title: 'Extraction statistiques dossier par date',
        fileName: 'extraction_saisie',
      }
    }
  }
</script>


